import { sum } from "lodash";
import React, { FC, ReactElement } from "react"
import { View, ViewStyle, ScrollView, Text, StyleSheet, TextStyle } from "react-native";
import Colors from "../../constants/Colors";
import FontStyles from "../../constants/FontStyle";

interface IProps {
    headerArr: (string | ReactElement)[],
    bodyArr: (string | ReactElement)[][],
    flexArr: number[],

    tableStyle?: ViewStyle,
    headerRowStyle?: ViewStyle,
    headerCellStyle?: ViewStyle,
    bodyRowStyle?: ViewStyle,
    bodyCellStyle?: ViewStyle,
    bodyCellTextStyle?: TextStyle,
    stickyArr?: number[],
    numericIndices?: number[],
}

/**
 * 
 * @param param0 
 */
const Table: FC<IProps> = ({
    flexArr,
    tableStyle,
    headerRowStyle,
    headerCellStyle,
    bodyRowStyle,
    bodyCellStyle,
    bodyCellTextStyle,
    headerArr,
    bodyArr,
    stickyArr,
    numericIndices,
}) => {
    return <>
        <ScrollView
            stickyHeaderIndices={stickyArr || []}
            contentContainerStyle={tableStyle || null}
        >
            <View
                style={[
                    styles.headerRow,
                    headerRowStyle || null
                ]}>
                {
                    headerArr.map((heading, index) => {

                        return <View key={index} style={[
                            styles.headerCell,
                            headerCellStyle || null,
                            flexArr[index] ? { width: ((flexArr[index] / sum(flexArr)) * 100) + '%' } : null
                        ]}>
                            {
                                (typeof heading === 'string')
                                    ? <Text style={[
                                        styles.headerCellText,
                                        numericIndices?.find(idx => idx === index) ? { textAlign: 'right' } : null
                                    ]}>{heading}</Text>
                                    : heading
                            }
                        </View>
                    })
                }
            </View>

            <ScrollView>
                {
                    bodyArr.map((row, index) => <View key={index}
                        style={[
                            styles.bodyRow,
                            bodyRowStyle || null
                        ]}>
                        {
                            row.map((data, index) => {
                                return <View
                                    key={index}
                                    style={[
                                        styles.bodyCell,
                                        bodyCellStyle || null,
                                        flexArr[index] ? { width: ((flexArr[index] / sum(flexArr)) * 100) + '%' } : null
                                    ]}>
                                    {
                                        (typeof data === 'string')
                                            ? <Text style={[
                                                styles.bodyCellText,
                                                bodyCellTextStyle,
                                                numericIndices?.find(idx => idx === index) ? { textAlign: 'right' } : null
                                            ]}>{data}</Text>
                                            : data
                                    }
                                </View>
                            })
                        }
                    </View>
                    )
                }
            </ScrollView>
        </ScrollView>
    </>
}

export default Table

const styles = StyleSheet.create({
    headerRow: {
        flexDirection: 'row',
        paddingHorizontal: 6,
        paddingVertical: 6,
        borderBottomColor: Colors.borderColor,
        borderBottomWidth: 2,
        borderStyle: 'solid'
    },
    headerCell: {
        padding: 4
    },
    headerCellText: {
        ...FontStyles.dark,
        ...FontStyles.medium,
        ...FontStyles.size13,
        ...FontStyles.lh15
    },
    bodyRow: {
        flexDirection: 'row',
        paddingHorizontal: 6,
        paddingVertical: 6,
        borderBottomColor: Colors.borderColor,
        borderBottomWidth: 1,
        borderStyle: 'solid'
    },
    bodyCell: {
        padding: 4,
    },
    bodyCellText: {
        ...FontStyles.dark,
        ...FontStyles.normal,
        ...FontStyles.size12,
        ...FontStyles.lh14
    }
})
